module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_9-35a8e4c2ad31a26bcb8e2102b2428baa.jpg";